"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CostCentersList;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
var _api = require("@focaltec-suite/api");
var _core = require("@focaltec-suite/core");
var _commons = require("@focaltec-suite/commons");
var _exportable = require("../exportable");
var _CostCenterMenu = _interopRequireDefault(require("./CostCenterMenu"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function CostCentersList() {
  var _a;
  var history = (0, _reactRouterDom.useHistory)();
  var qs = (0, _reactRouterDom.useLocation)().search;
  var query = (0, _react.useMemo)(function () {
    return new URLSearchParams(qs);
  }, [qs]);
  var params = (0, _commons.useSearchParams)(query);
  var context = (0, _react.useContext)(_core.AppContext);
  var access = context.access;
  var tenantId = ((_a = access === null || access === void 0 ? void 0 : access.tenant) === null || _a === void 0 ? void 0 : _a.id) || '-';
  var _useState = (0, _react.useState)('loading'),
    _useState2 = _slicedToArray(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    data = _useState4[0],
    setData = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedCostCenters = _useState6[0],
    setSelectedCostCenters = _useState6[1];
  var isCreateGranted = (0, _react.useMemo)(function () {
    return context.isGrantedAny(['PCostCentersCreate', 'TCostCentersCreate']);
  }, [context]);
  var clearCallback = (0, _react.useCallback)(function () {
    return setData(undefined);
  }, []);
  var _usePagination = (0, _commons.usePagination)(clearCallback),
    page = _usePagination.page,
    pageSize = _usePagination.pageSize,
    onChangedPage = _usePagination.onChangedPage,
    onChangedPageSize = _usePagination.onChangedPageSize;
  var retrievePromise = (0, _react.useCallback)(function () {
    var offset = (0, _commons.getOffset)(page, pageSize);
    return (0, _api.listCostCenters)(tenantId, Object.assign(Object.assign({}, params), {
      page: pageSize,
      offset: offset
    }), {
      access: access
    });
  }, [tenantId, page, pageSize, params, access]);
  var reload = (0, _react.useCallback)(function () {
    setData(undefined);
    setStatus('loading');
    retrievePromise().then(function (response) {
      setData(response);
      setStatus('loaded');
    })["catch"](function (error) {
      setStatus(error);
    });
  }, [retrievePromise]);
  (0, _react.useEffect)(reload, [reload]);
  var onDeleted = (0, _react.useCallback)(function (costCenter) {
    reload();
  }, [reload]);
  var onActivated = (0, _react.useCallback)(function (response) {
    setData(function (curr) {
      if (!curr) return curr;
      return Object.assign(Object.assign({}, curr), {
        items: curr.items.map(function (el) {
          if (el.id === response.id) {
            return response;
          }
          return el;
        })
      });
    });
  }, []);
  var onClicked = (0, _react.useCallback)(function (costCenter) {
    history.push(context.fixPath("/cost-centers/".concat(costCenter.id, "/edit")));
  }, [history, context]);
  return /*#__PURE__*/_react["default"].createElement(_commons.Pagination, {
    title: (0, _core.translate)('cost_centers.title'),
    icon: /*#__PURE__*/_react["default"].createElement(_commons.CostCentersIcon, null),
    page: page,
    pageSize: pageSize,
    count: data ? data.items.length : 0,
    total: data ? data.count : 0,
    onChangedPage: onChangedPage,
    onChangedPageSize: onChangedPageSize,
    buttons: [{
      variant: 'primary',
      text: (0, _core.translate)('buttons.add'),
      icon: /*#__PURE__*/_react["default"].createElement(_commons.AddIcon, null),
      path: context.fixPath('/cost-centers/new'),
      available: isCreateGranted
    }],
    ellipsisBuilder: function ellipsisBuilder() {
      return /*#__PURE__*/_react["default"].createElement(_exportable.ExportableComponent, {
        tenantId: tenantId !== null && tenantId !== void 0 ? tenantId : '',
        familyId: "cost_centers",
        selectedIds: selectedCostCenters,
        total: data === null || data === void 0 ? void 0 : data.count,
        createAction: ['PCostCentersCreate', 'TCostCentersCreate'],
        getAction: ['PCostCentersRead', 'TCostCentersRead'],
        onImported: reload,
        getImportPromise: function getImportPromise(file, tenantId) {
          return (0, _api.importCostCenters)(tenantId !== null && tenantId !== void 0 ? tenantId : '-', {
            name: file.name,
            path: file.path
          }, {
            access: access
          });
        },
        getTemplatePromise: function getTemplatePromise(connectorId, tenantId) {
          return (0, _api.downloadImportCostCentersTemplate)(tenantId !== null && tenantId !== void 0 ? tenantId : '-', connectorId, {
            access: access
          });
        },
        getExportSelectedPromise: function getExportSelectedPromise(connectorId, tenantId) {
          return (0, _api.exportSelectedCostCenters)(tenantId !== null && tenantId !== void 0 ? tenantId : '-', connectorId, selectedCostCenters, {
            access: access
          });
        },
        getExportWithParamsPromise: function getExportWithParamsPromise(connectorId, tenantId, startDate, endDate) {
          return (0, _api.exportCostCenters)(tenantId !== null && tenantId !== void 0 ? tenantId : '-', connectorId, Object.assign(Object.assign({}, params), {
            page: 0,
            offset: 0
          }), {
            access: access
          });
        }
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(_commons.SearchFilter, {
    label: (0, _core.translate)('cost_centers.filter'),
    query: query
  }), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    mx: -2,
    mt: 2
  }, /*#__PURE__*/_react["default"].createElement(_material.Divider, null), /*#__PURE__*/_react["default"].createElement(_commons.DataGrid, {
    items: data ? data.items : [],
    loading: status === 'loading',
    error: status instanceof Error ? status.message : undefined,
    empty: (0, _core.translate)('cost_centers.empty'),
    getId: function getId(costCenter) {
      return costCenter.id;
    },
    clickable: {
      onClick: onClicked
    },
    refreshable: {
      columnId: 'actions',
      onClick: reload
    },
    selectable: {
      selected: selectedCostCenters,
      onChange: function onChange(ids, items) {
        setSelectedCostCenters(ids);
      }
    },
    columns: [{
      title: (0, _core.translate)('cost_centers.id'),
      converter: function converter(costCenter) {
        return costCenter.id;
      },
      id: 'id',
      fixed: 'left'
    }, {
      title: (0, _core.translate)('cost_centers.name'),
      converter: function converter(costCenter) {
        return costCenter.name;
      },
      id: 'name'
    }, {
      title: (0, _core.translate)('status.title'),
      converter: function converter(costCenter) {
        return (0, _core.translate)("status.male.".concat(costCenter.status));
      },
      id: 'status',
      width: 150
    }, {
      title: /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
        size: "small",
        style: {
          visibility: 'hidden'
        },
        disabled: true
      }, /*#__PURE__*/_react["default"].createElement(_commons.EllipsisIcon, null)),
      converter: function converter(costCenter) {
        return /*#__PURE__*/_react["default"].createElement(_CostCenterMenu["default"], {
          key: costCenter.id,
          costCenter: costCenter,
          onDeleted: onDeleted,
          onActivated: onActivated
        });
      },
      id: 'actions',
      fixed: 'right',
      width: 60,
      textAlign: 'center'
    }]
  })));
}